/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @typedef {Object} CalculationInfo
 * @property {String} operator - operator of the calculation
 * @property {String[]} operands - list of operands of the calculation
 */

/**
 * @class QueryDataItemSetAPI
 * @hideconstructor
 * @classdesc API class for sets of Data Items - loosely, an abstraction of an edge or slot.
 * It holds Data Items which are unioned together, and Data Item Sets, which are nested.
 */
define([], () => {
	class QueryDataItemSetAPI {
		/**
		 * Add a data item to this set
		 * @param {DataItemAPI} dataItem
		 */
		addDataItem() {}

		/**
		 * Add an array of data items to this set
		 * @param {DataItemAPI[]} dataItems
		 */
		addDataItemList() {}

		/**
		 * Replace the existing dataItems with the new one.
		 * @param {DataItemAPI[]} dataItems An array of {@DataItemAPI} to replace the existing one.
		 */
		setDataItemList() {}

		/**
		 * Get all data items in this set
		 * @return {DataItemAPI[]}
		 */
		getDataItemList() {}

		/**
		 * @param {DataItemAPI[]} dataItems An array of one or more data items to initialize the QueryDataItemSetAPI with
		 * @return {QueryDataItemSetAPI}
		 */
		createDataItemSet() {}

		/**
		 * Get all data item sets in this set
		 * @return {QueryDataItemSetAPI[]}
		 */
		getDataItemSetList() {}

		/**
		 * Get all data items in this set and its descendants
		 * @return {QueryDataItemAPI[]}
		 */
		getAllDataItemsList() {}

		/**
		 * Return true if this dataItemSet contains facts.
		 * @return {Boolean}
		 */
		isMeasureItemSet() {}

		/**
		 * Return true if this dataItemSet is nested (includes a non-empty dataItemSets member)
		 * @return {Boolean}
		 */
		isNestedItemSet() {}

		/**
		 * @return {String} - the constant summary data item name prefix (summary:)
		 */
		getSummaryItemPrefix() {}

		/**
		 * @return {Boolean} - true if this id represents a summary dataItem (starts with 'summary:')
		 */
		isSummaryItemId() {}

		/**
		 * @function QueryDataItemSetAPI#addCalculation
		 * Add calculation to a measure item set
		 * @param {String} operator operator of the calculation
		 * @param {String[]} dataItemIds dataItem operands of the calculation
		 */
		addCalculation() {}

		/**
		 * @function QueryDataItemSetAPI#getCalculationList
		 * Get list of calculations of a measure item set
		 * @param {String} [dataItemId] dataItem operand of the calculation. Returns all calculations if omitted.
		 * @return {CalculationInfo[]} list of calculations
		 */
		getCalculationList() {}
	}

	return QueryDataItemSetAPI;

});
